import { render, staticRenderFns } from "./CatalogSettings.vue?vue&type=template&id=1a3608ef&scoped=true"
import script from "./CatalogSettings.vue?vue&type=script&lang=js"
export * from "./CatalogSettings.vue?vue&type=script&lang=js"
import style0 from "./CatalogSettings.vue?vue&type=style&index=0&id=1a3608ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3608ef",
  null
  
)

export default component.exports